export const RIGHT = 'RIGHT';
export const LEFT = 'LEFT';
